<template>
  <v-dialog
    v-model="authStore.isLoginModalOpen"
    max-width="500"
    persistent
    scrim="rgba(0, 0, 0, 0.9)"
    content-class="dialog-visible-overflow"
  >
    <v-card class="pa-6 custom-card card-visible-overflow">
      <v-btn
        icon
        size="small"
        class="close-btn"
        color="white"
        elevation="2"
        @click="handleClose"
      >
        <v-icon color="black">mdi-close</v-icon>
      </v-btn>

      <v-card-title class="text-h6 text-center">
        Poranos に{{ isSignupMode ? "サインアップ" : "ログイン" }}
      </v-card-title>

      <v-form @submit.prevent="handleEmailSubmit">
        <v-text-field
          v-model="email"
          placeholder="name@example.com"
          type="email"
          variant="outlined"
          color="white"
          class="mb-4 custom-text-field"
        />

        <v-text-field
          v-if="email"
          v-model="password"
          placeholder="パスワード"
          type="password"
          variant="outlined"
          color="white"
          class="mb-4 custom-text-field"
        />

        <v-text-field
          v-if="password && isSignupMode"
          v-model="confirmPassword"
          placeholder="パスワード確認"
          type="password"
          variant="outlined"
          color="white"
          class="mb-4 custom-text-field"
        />

        <v-btn type="submit" color="#1b5e20" class="mt-2 rounded-lg" block>
          <span style="color: white">
            {{ isSignupMode ? "サインアップ" : "ログイン" }}
          </span>
        </v-btn>
      </v-form>

      <v-divider class="my-4" />

      <v-btn
        color="white"
        class="rounded-lg"
        block
        @click="googleAuth"
      >
        <v-icon start>mdi-google</v-icon>
        Googleでログイン
      </v-btn>

      <div class="text-center mt-4">
        <span
          v-if="!isSignupMode"
          class="text-caption text-primary cursor-pointer"
          @click="onForgotPassword"
        >
          パスワードを忘れた場合はこちら
        </span>
      </div>
      <div class="text-center mt-2">
        <span
          class="text-caption text-primary cursor-pointer"
          @click="toggleMode"
        >
          {{ isSignupMode ? "ログインはこちら" : "サインアップはこちら" }}
        </span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { useRouter } from "vue-router";

const props = defineProps({
  modelValue: Boolean,
});
const emit = defineEmits(["update:modelValue", "login-success"]);

const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const isSignupMode = ref(false);
const authStore = useAuthStore();
const router = useRouter();

const googleAuth = async () => {
  try {
    const success = await authStore.loginWithGoogle();
    if (success) {
      emit("login-success");
      authStore.closeLoginModal();
      router.push("/rooms");
    }
  } catch (err) {
    console.error("Googleログイン失敗", err);
  }
};

const onForgotPassword = async () => {
  if (!email.value) {
    alert("パスワードリセットにはメールアドレスの入力が必要です");
    return;
  }
  await authStore.sendPasswordReset(email.value);
  authStore.closeLoginModal();
};

const handleEmailSubmit = async () => {
  if (!email.value) {
    alert("メールアドレスを入力してください");
    return;
  }
  if (!password.value) {
    alert("パスワードを入力してください");
    return;
  }
  if (isSignupMode.value && password.value !== confirmPassword.value) {
    alert("パスワードが一致しません");
    return;
  }
  try {
    if (isSignupMode.value) {
      await authStore.signup(email.value, password.value);
    } else {
      await authStore.login(email.value, password.value);
    }
    authStore.closeLoginModal();
    emit("login-success");
    router.push("/rooms");
  } catch (error) {
    // エラーはauthStore側で表示済み
  }
};

const toggleMode = () => {
  isSignupMode.value = !isSignupMode.value;
  confirmPassword.value = "";
};

const resetForm = () => {
  email.value = "";
  password.value = "";
  confirmPassword.value = "";
  isSignupMode.value = false;
};

const handleClose = () => {
  resetForm();
  authStore.closeLoginModal();
};

watch(
  () => authStore.isLoginModalOpen,
  (opened) => {
    if (opened) {
      resetForm();
    }
  }
);
</script>

<style scoped>
.dialog-visible-overflow {
  overflow: visible !important;
  position: relative; /* ← absolute配置の基準にするため必要 */
}

.fill-height {
  height: 100vh;
  background-color: #121212;
}

.custom-card {
  background-color: #e0f2e9;
  color: #1b5e20;
  border-radius: 12px;
}

.card-visible-overflow {
  overflow: visible !important;
  position: relative;
}

/* Vuetify 3: inputフォーカス時にも枠・ラベルを深緑に */
:deep(.custom-text-field .v-field__outline) {
  border-color: #1b5e20;
}

:deep(.custom-text-field .v-field--focused .v-field__outline) {
  border-color: #1b5e20 !important;
}

:deep(.custom-text-field .v-label) {
  color: #1b5e20 !important;
}

:deep(.custom-text-field input::placeholder) {
  color: #4e6e58;
}
.close-btn {
  position: absolute;
  top: -16px;
  right: -16px;
  z-index: 100;
  border-radius: 999px;
}

/* ボタンやテキストにも適用したい場合 */
:deep(.v-btn),
:deep(.v-card-title),
:deep(.text-caption),
:deep(.text-h6),
:deep(.v-icon) {
  color: #1b5e20 !important;
}
</style>
